import { z } from 'zod';
import { TimestampSchema } from './primitives.js';

/**
 * users/{uid}/fcmTokens/{tokenId}
 *
 * Per-device FCM registration. One user can have many tokens (phone + tablet +
 * desktop installable). On send-failure (token expired, app uninstalled) the
 * Cloud Function deletes the stale entry.
 *
 * `tokenId` doc id = the registration token itself (sanitised) so duplicate
 * registrations idempotently collapse to a single row.
 */
export const FcmTokenSchema = z.object({
  /** The FCM registration token. Treated as opaque. */
  token: z.string().min(10),
  platform: z.enum(['web', 'android', 'ios']),
  /** Optional human-readable hint (e.g., "Chrome on Windows", "iPhone Safari"). */
  deviceLabel: z.string().max(60).optional(),
  createdAt: TimestampSchema,
  lastUsedAt: TimestampSchema,
});
export type FcmToken = z.infer<typeof FcmTokenSchema>;
